<mat-form-field appearance="outline" [formGroup]="formulario" [ngClass]="classe">
  <mat-label>{{descricao}}</mat-label>
  <input class="text-left"
    matInput
    [type]="tipo"
    (cdkAutofill)="handleAutoFill($event)"
    [attr.inputmode]="modoInsercao"
    [formControlName]="nomeControle"
    [autocomplete]="autoPreenchimento"
    [id]="identificacao"
    [mask]="mascara"
    (change)="change()"
    (focus)="focus()"
  />

  <app-botao *ngIf="botaoAcao"
    matSuffix
    icone="fas fa-search"
    (clique)="change()"
  ></app-botao>
  <mat-hint>{{formulario?.controls[nomeControle]?.errors ? textoAjuda : ''}}</mat-hint>
</mat-form-field>
